import { render, staticRenderFns } from "./viteadd.vue?vue&type=template&id=221e85ce&scoped=true&"
import script from "./viteadd.vue?vue&type=script&lang=js&"
export * from "./viteadd.vue?vue&type=script&lang=js&"
import style0 from "./viteadd.vue?vue&type=style&index=0&id=221e85ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221e85ce",
  null
  
)

export default component.exports